import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { useMemo as z } from "react";
import { AvatarList as L } from "../../../atoms/AvatarList/AvatarList.es.js";
import { Checkbox as S } from "../../../atoms/Checkbox/Checkbox.es.js";
import { Paragraph as t } from "../../../atoms/Paragraph/Paragraph.es.js";
import { BoolStr as l } from "../../../utils/bool.es.js";
import { forwardRef as D, useMultiStyleConfig as P, chakra as a } from "@chakra-ui/react";
import { PinFilledIcon as w } from "../../../icons/index.es.js";
const T = D(
  (p, f) => {
    const {
      createdAt: h,
      firstFourCreator: s,
      id: u,
      isDisabled: n,
      isChecked: c,
      name: _,
      onClick: v,
      order: d,
      ownerName: y,
      totalCreator: m,
      ...k
    } = p, C = new Date(h), b = typeof d == "number", r = P("SavedListItem"), g = z(
      () => s.map(({ avatar: i, name: x }) => ({ src: i, alt: x })),
      [s]
    );
    return /* @__PURE__ */ o(
      a.div,
      {
        __css: r.root,
        "data-checked": l(c),
        "data-disabled": l(n),
        "data-group": !0,
        "data-testid": u,
        onClick: n ? void 0 : v,
        ref: f,
        style: { order: d },
        ...k,
        children: [
          /* @__PURE__ */ e(
            S,
            {
              __css: r.checkbox,
              isChecked: c,
              onClick: (i) => i.preventDefault()
            }
          ),
          /* @__PURE__ */ e(L, { __css: { borderRadius: "radius-100" }, size: "sm", avatars: g }),
          /* @__PURE__ */ o(a.div, { __css: { flex: 1, ...r.content }, children: [
            /* @__PURE__ */ e(
              t,
              {
                color: "primary.700",
                fontWeight: "medium",
                size: "lg",
                marginBottom: "auto",
                noOfLines: 1,
                children: _
              }
            ),
            /* @__PURE__ */ e(t, { color: "primary.700", size: "md", noOfLines: 1, children: y }),
            /* @__PURE__ */ o(t, { color: "primary.300", size: "md", children: [
              m,
              " ",
              m <= 1 ? "Talent" : "Talents"
            ] })
          ] }),
          /* @__PURE__ */ e(a.div, { __css: { ...r.content, ...r.contentAdditional }, children: /* @__PURE__ */ o(t, { color: "primary.300", size: "md", children: [
            b && /* @__PURE__ */ e(w, { boxSize: 4 }),
            " ",
            C.toLocaleDateString()
          ] }) })
        ]
      }
    );
  }
);
export {
  T as SavedListItem
};
//# sourceMappingURL=SavedListItem.es.js.map
